<div class="flex h-screen w-full items-center justify-center bg-gray-50">
  <div
    class="success-wrapper mx-auto w-full max-w-md rounded-lg bg-white p-8 shadow-lg">
    <div class="flex flex-col items-center justify-center gap-6">
      <!-- PayS Logo -->
      <div class="mb-2">
        <img src="assets/img/payS_1.png" alt="PayS logo" class="h-10 w-auto" />
      </div>

      <!-- Success Icon -->
      <div class="relative flex h-20 w-20 items-center justify-center">
        <!-- Animated ring -->
        <div
          class="absolute h-20 w-20 animate-ping rounded-full bg-green-400 opacity-75"></div>
        <!-- Solid background -->
        <div
          class="relative flex h-20 w-20 items-center justify-center rounded-full bg-green-100">
          <svg
            class="h-12 w-12 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>

      <!-- Success Message -->
      <div class="flex flex-col items-center gap-2">
        <h2 class="text-center text-2xl font-semibold text-gray-800">
          Payment Successful
        </h2>
        <p class="text-center text-base text-gray-600">
          You paid
          <span class="font-semibold text-gray-900">
            {{ amount | currency : 'NGN' : 'NGN ' : '1.2-2' }}
          </span>
        </p>
      </div>

      <!-- Additional Info -->
      <div class="mt-4 w-full rounded-lg bg-gray-50 p-4">
        <p class="text-center text-sm text-gray-600" *ngIf="canRedirect">
          Your payment has been processed successfully. You will be redirected
          shortly.
        </p>
        <p class="text-center text-sm text-gray-600" *ngIf="!canRedirect">
          Your payment has been processed successfully.<br />You can now close
          this page.
        </p>
      </div>
    </div>
  </div>
</div>
